import { CharterDetailsGetRes } from '~/services/CharterService';

import {
  CabinOverridesPayload,
  CharterDetails,
  CharterFlight,
  CharterFlightPayload,
  SeatConfiguration,
} from '../charter.types';

import { generateSeatMap } from './generateSeatMap';

export const deriveCharterDetails = (response: CharterDetailsGetRes['result']): CharterDetails => ({
  pnr: response.pnr,
  travellers: response.travelers,
  flights: deriveCharterFlights(response.flights),
});

const applyOverrides = (base: SeatConfiguration, flightOverrides?: Array<CabinOverridesPayload>): SeatConfiguration => {
  if (!flightOverrides?.length) {
    return base;
  }

  return {
    ...base,
    cabins: base.cabins.map((cabin) => {
      const delta = flightOverrides.find((override) => override.cabin === cabin.cabin);

      if (!delta) {
        return cabin;
      }

      return {
        ...cabin,
        overrides: (cabin.overrides ?? []).concat(delta.overrides),
      };
    }),
  };
};

const deriveCharterFlights = (flights: Array<CharterFlightPayload>): Array<CharterFlight> => {
  return flights.map((flight) => {
    const configuration = applyOverrides(flight.seatConfiguration, flight.overrides);
    return {
      ...flight,
      cabinLayout: generateSeatMap(configuration),
      seatConfiguration: configuration,
    };
  });
};
